"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var React = require("react");
var react_apollo_1 = require("react-apollo");
var Localize_1 = require("../../../gen-src/Localize");
var DataDetailsViewUpstreamDataQualityWarningsQueryGql_1 = require("../../queries/DataDetailsViewUpstreamDataQualityWarningsQueryGql");
var renderQueryResult_1 = require("../renderQueryResult");
function DataQualityWarningViewHeader(props) {
    return (React.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return React.createElement(react_apollo_1.Query, { query: DataDetailsViewUpstreamDataQualityWarningsQueryGql_1.DataDetailsViewUpstreamDataQualityWarningsQueryGql, variables: { datasourceIds: props.datasourceIds, first: 10, offset: 0 } }, function (result) { return renderQueryResult_1.renderQueryResult(result, {
            renderData: renderWarnings(urls),
            renderDataWithError: renderWarningsWithError(urls),
        }); });
    }));
}
exports.DataQualityWarningViewHeader = DataQualityWarningViewHeader;
// Render warnings with a particular error code having been returned.
function renderWarningsWithError(urls) {
    return function (data, errorCode) {
        // Ignore the PERMISSIONS_MODE_SWITCHED error, which should not block Data Details from being shown
        if (errorCode === null || errorCode === 'PERMISSIONS_MODE_SWITCHED') {
            return renderWarnings(urls)(data);
        }
        else {
            return data_catalog_shared_1.reportGraphQLError(errorCode); // Behave as renderQueryResult would have
        }
    };
}
function renderWarnings(urls) {
    return function (data) {
        if (!data.embeddedDatasources) {
            return null;
        }
        var dqwMap = {};
        // Go through our upstream data quality warnings and add them to a map by id to eliminate duplicates
        data.embeddedDatasources.forEach(function (eds) {
            if (eds.upstreamDataQualityWarningsConnection) {
                eds.upstreamDataQualityWarningsConnection.nodes.forEach(function (dqw) {
                    dqwMap[dqw.id] = dqw;
                });
            }
        });
        // Turn the map into an array
        var dqwList = Object.keys(dqwMap).map(function (key) { return dqwMap[key]; });
        var props = {
            urls: urls,
            iconOnly: false,
            side: 'left',
            anchoredDataQualityWarnings: [],
            upstreamDataQualityWarnings: dqwList
        };
        return dqwList.length !== 0 ? (React.createElement(data_catalog_shared_1.MetadataTable.Row, null,
            React.createElement(data_catalog_shared_1.MetadataTable.LabelCell, { "data-tb-test-id": 'data-details-consolidated-data-quality-warning' }, Localize_1.Messages.DataQualityWarningsLabel()),
            React.createElement(data_catalog_shared_1.MetadataTable.ValueCell, null,
                React.createElement(data_catalog_shared_1.RenderWarningsFromGraph, __assign({}, props))))) : null;
    };
}
//# sourceMappingURL=DataQualityWarningViewHeader.js.map